<template>
  <BaseLightBox :boxNumber="3" :mode="mode">
    <template #title>
      <v-skeleton-loader
        v-if="loading"
        type="text"
        width="120"
        class="skeleton-loader"
      ></v-skeleton-loader>
      <span v-else>{{ $t("SingelDoc.Remarks") }}</span>
    </template>
    <div class="ordernotes">
      <InnerBox :class="[editableClass]">
        <template #content>
          <v-skeleton-loader
            v-if="loading"
            type="paragraph"
            class="skeleton-loader skeleton-textarea"
          ></v-skeleton-loader>
          <textarea
            v-else
            v-model="inputNotes"
            :class="[editableTextAreaClass]"
            :disabled="!editable"
            @change="
              () => {
                this.$emit('update:modelValue', inputNotes);
              }
            "
            @blur="
              () => {
                if (this.inputNotes.trim().length === 0)
                  this.inputNotes = this.note;
              }
            "
            cols="50"
          />
        </template>
      </InnerBox>
    </div>
  </BaseLightBox>
</template>

<script>
import BaseLightBox from "../UI/BaseLightBox.vue";
import InnerBox from "../UI/InnerBox.vue";

export default {
  components: { BaseLightBox, InnerBox },
  data() {
    return {
      inputNotes: "",
      loading: true,
    };
  },
  emits: ["update:modelValue"],
  props: {
    modelValue: String,
    editable: {
      type: Boolean,
      default: false,
    },
    note: {
      type: String,
    },
    mode: {
      type: String,
    },
  },
  watch: {
    note: {
      immediate: true,
      handler() {
        // Add a small delay to simulate loading
        setTimeout(() => {
          this.loading = false;
          this.setNote();
        }, 200);
      },
    },
  },
  mounted() {
    this.setNote();
  },
  methods: {
    setNote() {
      if (this.note) {
        this.inputNotes = this.cleanHtmlFromNotes(this.note);
        if (!this.editable)
          this.inputNotes = this.cleanHtmlFromNotes(this.note);
      }
    },
    cleanHtmlFromNotes(notes) {
      // First remove the style definition
      notes = notes.replace(/p,div,li {[^}]+}/, "");

      // Remove any HTML tags
      notes = notes.replace(/<[^>]+>/g, "");

      // Decode HTML entities
      notes = notes
        .replace(/&quot;/g, '"')
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">");

      // Remove extra whitespace
      notes = notes.replace(/\s+/g, " ").trim();

      return notes;
    },
  },
  computed: {
    editableClass() {
      return this.editable && this.mode !== "orders" ? "editable" : "";
    },
    editableTextAreaClass() {
      return this.editable && this.mode !== "cart" && this.mode !== "invoices"
        ? "editable"
        : "";
    },
  },
};
</script>

<style scoped lang="scss">
textarea {
  height: 4.2rem;
  padding: 0 !important;
  width: 100%;
  font-size: $mediumTextSize;
  font-weight: 400;
  line-height: 21.33px;
  text-align: right;
  color: $orderLineColor;
}

textarea.editable {
  border: 1px solid #ececec !important;
  background: #ffffff !important;
  border-radius: 10px;
  padding: 15px !important;
}

textarea:focus {
  outline: unset;
}

.editable {
  border: 1px solid #ececec !important;
  background-color: transparent !important;
}

/* Skeleton loader styles */
::v-deep .skeleton-loader {
  border-radius: 8px;
}

::v-deep .skeleton-textarea {
  height: 4.2rem;
  margin: 0;
  padding: 0;
  background-color: #f5f5f5;
}
</style>
